import offcanvas from '../util/offcanvas';
import initGmap from '../util/gmap';

export default {
  init() {
    // JavaScript to be fired on all pages
    offcanvas();
    initGmap();

    // tooltip
    $('[data-toggle="tooltip"]').tooltip();

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js